<template>
  <div>
    <Layout/>
    <h4>Examen Físico</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idExamenFisico" class="form-label">IdExamenFisico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamenFisico" name="idExamenFisico" v-model="datoExamenFisico.idExamenFisico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoExamenFisico.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoExamenFisico.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarExamenFisico" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamenFisico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamenFisico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdExamAten</th>
          <th scope="col">IdExamenFisico</th>
          <th scope="col">IdAtencion</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">ExamenFisicoNombre</th>
          <th scope="col">AtencionFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="examaten in datosPaginados" :key="examaten.idExamAten">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(examaten.idExamAten)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(examaten.idExamAten)" title="Editar">edit_square</i></td>
          <td>{{examaten.idExamAten}}</td>
          <td>{{examaten.idExamenFisico}}</td>
          <td>{{examaten.idAtencion}}</td>
          <td>{{examaten.observacion}}</td>
          <td>{{examaten.estado}}</td>
          <td>{{examaten.examenFisicoNombre}}</td>
          <td>{{getFormattedDate(examaten.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteExamenFisico(examaten.idExamAten)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idExamAten" class="form-label">IdExamAten</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamAten" name="idExamAten" v-model="datoExamAten.idExamAten" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idExamenFisico" class="form-label">IdExamenFisico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamenFisico" name="idExamenFisico" v-model="datoExamAten.idExamenFisico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idAtencion" name="idAtencion" v-model="datoExamAten.idAtencion"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="atencion" name="atencion" v-model="datoExamAten.atencion" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalAtencionLOV"
                      title="Buscar Diagnósticos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoExamAten.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamAten" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamAten" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: ExamAten -->
    <ExamAtenLOVdet @DatosExamAten="GetDataExamAtenLOVdet($event)"/>
<!-- Lista de Valores: Atencion -->
    <AtencionLOVdet @DatosAtencion="GetDataAtencionLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import ExamAtenLOVdet from '../../components/lovs/ExamAtenLOV.vue'
import AtencionLOVdet from '../../components/lovs/AtencionLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, ExamAtenLOVdet
, AtencionLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      examenfisicos : [],
      datoExamenFisico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idExamenFisico: '',
// Variables master
// Variables details
      examatens : [],
      datoExamAten : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idExamenFisico = this.$route.params.p_idexamenfisico
    this.abrirEditar(this.p_idExamenFisico)
    this.getExamAtens()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoExamenFisico.idExamenFisico === ''){
        swal("Error!", "El elemento idExamenFisico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoExamenFisico.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoExamenFisico.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoExamenFisico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarExamenFisico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examenfisicos', this.datoExamenFisico)
          swal("Correcto!", "ExamenFisico creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamenFisico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examenfisicos', this.datoExamenFisico)
          swal("Correcto!", "ExamenFisico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoExamenFisico={}
      this.titulo   = 'Crear Examen Físico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idExamenFisico){
      this.modalWindow = true
      if(idExamenFisico != null){    
           api.get('/vwexamenfisicos/'+idExamenFisico).then(resp=>{
          this.datoExamenFisico = resp.data;
           });
      }
      this.titulo   = 'Editar Examen Físico'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarExamenFisico(){
      this.$router.push('/ExamenFisico')
    },
// Procedimientos master
// Procedimientos detalle
    async getExamAtens() {
      const resp = await api.get('/examatens')
      this.examatens = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.examatens.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwexamatens/nombre/'+this.nombreBusqueda).then(response=>{
          this.examatens=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.examatens.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwexamatens').then(response=>{
      this.examatens=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.examatens.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoExamAten.idExamenFisico === ''){
        swal("Error!", "El elemento idExamenFisico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoExamAten.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoExamAten.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoExamAten.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarExamAten(){
      if(this.validarForm() === 1){
        try {
          this.datoExamAten.idExamenFisico = this.datoExamenFisico.idExamenFisico;
          await api.post('/examatens', this.datoExamAten)
          this.getExamAtens();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ExamAten creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamAten(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examatens', this.datoExamAten)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ExamAten creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoExamAten={}
      this.titulo   = 'Crear Examen Físico'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idExamAten){
      this.modalWindow = true
      if(idExamAten != null){    
           api.get('/vwexamatens/'+idExamAten).then(resp=>{
          this.datoExamAten = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Examen Físico'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idExamAten){
      this.modalWindow = true
      if(idExamAten != null){
        this.$router.push('/examatenmd/'+idExamAten)
      }
    },
    async deleteExamAten (idExamAten) {
      try{
        await api.delete('/examatens/'+idExamAten)
          this.getExamAtens()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataExamAtenLOVdet(data) {
      this.datoExamAten.idExamAten = data.idExamAten;
      this.datoExamAten.examAten = data.nombre;
    },
//    Lista de Valores
    GetDataAtencionLOVdet(data) {
      this.datoExamAten.idAtencion = data.idAtencion;
      this.datoExamAten.atencion = data.nombre;
    },
// Listas de valores details
  },
}
</script>
